//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAlert } from 'react-alert';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { setSpinner } from 'services/store/actions/view';
import {
  getStorageOrders,
  deleteStorageOrder,
} from 'services/apiRequests/storage.api';
import OrdersTable from './StorageOrdersTab/OrdersTable';
import OrdersPagination from './StorageOrdersTab/OrdersPagination';
import ConfirmationModal from 'components/modals/ConfirmationModal';

const StorageOrdersTab = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const alert = useAlert();

  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pages: 1,
    total: 0,
  });
  const [filters, setFilters] = useState({
    status: '',
    producer: '',
  });
  const [producers, setProducers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    orderId: null,
    orderNumber: '',
  });

  const fetchOrders = async (page = 1, newFilters = filters) => {
    setLoading(true);
    dispatch(setSpinner(true));

    try {
      const queryParams = {
        ...newFilters,
        page,
        limit: 10,
        sortBy: 'createdAt',
        sortOrder: -1,
      };

      // Remove empty filters
      Object.keys(queryParams).forEach((key) => {
        if (
          !queryParams[key] &&
          key !== 'page' &&
          key !== 'limit' &&
          key !== 'sortBy' &&
          key !== 'sortOrder'
        ) {
          delete queryParams[key];
        }
      });

      const response = await getStorageOrders(queryParams);
      setOrders(response.orders || []);
      setPagination({
        page: response.pagination?.page || 1,
        pages: response.pagination?.pages || 1,
        total: response.pagination?.total || 0,
      });

      // Extract unique producers from orders
      if (response.orders && response.orders.length > 0) {
        const uniqueProducers = [
          ...new Set(
            response.orders
              .filter((order) => order.producer?.name)
              .map((order) => order.producer.name),
          ),
        ].sort();

        setProducers(uniqueProducers);
      }
    } catch (error) {
      console.error('Error fetching orders:', error);
      alert.error('Błąd pobierania zamówień');
    } finally {
      setLoading(false);
      dispatch(setSpinner(false));
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchOrders(1, filters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      status: '',
      producer: '',
    };
    setFilters(clearedFilters);
    fetchOrders(1, clearedFilters);
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({
      ...prev,
      page,
    }));
    fetchOrders(page, filters);
  };

  const handleOrderClick = (orderId) => {
    history.push(`/storage/orders/${orderId}`);
  };

  const handleDeleteOrder = async (orderId, orderNumber) => {
    setDeleteModal({
      show: true,
      orderId,
      orderNumber,
    });
  };

  const confirmDeleteOrder = async () => {
    try {
      dispatch(setSpinner(true));
      await deleteStorageOrder(deleteModal.orderId);
      alert.success('Zamówienie zostało usunięte pomyślnie');

      // Odśwież listę zamówień
      fetchOrders(pagination.page, filters);

      // Zamknij modal
      setDeleteModal({ show: false, orderId: null, orderNumber: '' });
    } catch (error) {
      console.error('Error deleting order:', error);
      alert.error('Błąd podczas usuwania zamówienia');
    } finally {
      dispatch(setSpinner(false));
    }
  };

  const closeDeleteModal = () => {
    setDeleteModal({ show: false, orderId: null, orderNumber: '' });
  };

  return (
    <Container fluid className="py-3">
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Zamówienia magazynowe</h5>
            </Card.Header>
            <Card.Body>
              {/* Filtry */}
              <Form onSubmit={handleFilterSubmit} className="mb-4">
                <Row>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Status</Form.Label>
                      <Form.Select
                        value={filters.status}
                        onChange={(e) =>
                          handleFilterChange('status', e.target.value)
                        }
                      >
                        <option value="">Wszystkie</option>
                        <option value="oczekuje">Oczekuje</option>
                        <option value="w realizacji">W realizacji</option>
                        <option value="zrealizowane">Zrealizowane</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Producent</Form.Label>
                      <Form.Select
                        value={filters.producer}
                        onChange={(e) =>
                          handleFilterChange('producer', e.target.value)
                        }
                      >
                        <option value="">Wszyscy producenci</option>
                        {producers.map((producer) => (
                          <option key={producer} value={producer}>
                            {producer}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    <Button
                      type="submit"
                      variant="primary"
                      className="me-2"
                    >
                      Filtruj
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={handleClearFilters}
                    >
                      Wyczyść
                    </Button>
                  </Col>
                </Row>
              </Form>

              {/* Informacje o wynikach */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <small className="text-muted">
                    Znaleziono {pagination.total} zamówień
                    {pagination.total > 0 && (
                      <span>
                        {' '}
                        (strona {pagination.page} z {pagination.pages})
                      </span>
                    )}
                  </small>
                </div>
                <div>
                  <small className="text-muted">
                    Wyświetlane: 10 na stronę
                  </small>
                </div>
              </div>

              {/* Lista zamówień */}
              <OrdersTable
                orders={orders}
                loading={loading}
                onOrderClick={handleOrderClick}
                onDeleteOrder={handleDeleteOrder}
              />

              {/* Paginacja */}
              {pagination.pages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <OrdersPagination
                    pagination={pagination}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal potwierdzenia usunięcia */}
      {deleteModal.show && (
        <ConfirmationModal
          title="Potwierdź usunięcie"
          description={`Czy na pewno chcesz usunąć zamówienie ${deleteModal.orderNumber}? Ta operacja jest nieodwracalna.`}
          handleSubmit={confirmDeleteOrder}
          closeModal={closeDeleteModal}
        />
      )}
    </Container>
  );
};

export default StorageOrdersTab;
